export default class {
  constructor() {
    
    // Splide を使うため、スライダーがあるページでだけ読み込む
    const domFeatureSliders = document.querySelectorAll('[data-js="feature-slider"]');
    if (domFeatureSliders.length) {
      import('./FeatureSlider').then(({ default: FeatureSlider }) => {
        domFeatureSliders.forEach(el => new FeatureSlider(el));
      });
    }

  }
}
